<!--超时退费-->
<template>
    <li>
        <div class="func-item">
            <span class="ui-ico sfi icon-overdue-refund2"></span>
            <span class="ui-btn-right"
                ><span class="text">{{ _ll('代表支持超时退费') }}</span
                ><span class="ui-ico ui-ico-right"></span
            ></span>
        </div>
    </li>
</template>

<script>
export default {
    name: 'OverdueRefund'
}
</script>

<style scoped>
@font-face {
    font-family: 'sf-express';
    src: url('/src/assets/fonts/sf-express.ttf?u2m6c4') format('truetype'), url('/src/assets/fonts/sf-express.woff?u2m6c4') format('woff'),
        url('/src/assets/fonts/sf-express.svg?u2m6c4#sf-express') format('svg');
    font-weight: normal;
    font-style: normal;
}
li {
    border-top: 0;
    border-bottom: #ddd 1px solid;
    list-style: none;
    font-size: 100%;
    font-weight: normal;
}
.func-item {
    min-height: 30px;
    padding-left: 50px;
    position: relative;
    z-index: 0;
    padding: 10px 10px 10px 60px;
    display: block;
}
a {
    cursor: pointer;
    color: #808080;
}
.func-item .ui-ico:first-child {
    position: absolute;
    top: 10px;
    left: 10px;
}
.ui-ico {
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    background-position: 50% 50%;
}
.icon-overdue-refund2:before {
    content: '\e046';
    height: 35px;
    width: 35px;
    color: #ec2200;
    font-size: 35px;
}
.ui-btn-right {
    padding-right: 30px;
    position: relative;
    z-index: 0;
    display: block;
}
.func-item .text {
    display: block;
    padding: 5px 0;
    color: #333;
}
.ui-ico-right {
    background: url(../../../assets/images/sixpart/ico_arrow_right.png) no-repeat right 50%;
    background-size: auto 20px;
    width: 10px;
}
.ui-ico-right {
    position: absolute;
    top: 0;
    right: 5px;
    display: block;
    width: 20px;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/additionalService/overdue-refund.vue